import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import {
    HiDocumentSearch,
    HiDatabase,
    HiCalculator,
    HiTemplate,
    HiDotsHorizontal,
    HiLogout,
    HiBookOpen,
} from 'react-icons/hi'
import { MdEmail } from 'react-icons/md'
import { BsClipboard2DataFill } from 'react-icons/bs'
import { RiDiscordFill } from 'react-icons/ri'
import { IconType } from 'react-icons'
import { useAuthStore } from '../../state/store'
import OutsideAlerter from '../../hooks/ClickOutside'
import { HiCurrencyDollar } from 'react-icons/hi2'

import { useTheme } from 'styled-components'
import {
    StyledDropDownLink,
    StyledDropDownLinkIcon,
    StyledDropDownMenu,
    StyledMoreContainer,
    StyledNavContainer,
    StyledNavIcon,
    StyledNavName,
    StyledNavItem,
} from './styles'
import { useClientConfig } from '../../hooks/useClientConfig'

type NavItemProps = {
    to: string
    Icon: IconType
    name: string
}

const NavItem = (props: NavItemProps) => {
    const { to, Icon, name } = props
    const theme = useTheme()
    return (
        <StyledNavItem as={NavLink} to={to}>
            {({ isActive }) => {
                return (
                    <>
                        <StyledNavIcon>
                            <Icon
                                color={
                                    isActive
                                        ? theme.colours.font.green
                                        : theme.colours.font.blue
                                }
                            />
                        </StyledNavIcon>
                        <StyledNavName>{name}</StyledNavName>
                    </>
                )
            }}
        </StyledNavItem>
    )
}

const DropDownMenu = () => {
    const [isOpened, SetIsOpened] = useState(false)
    const { logout } = useAuthStore((state) => state)
    const pressLogout = () => {
        window.localStorage.removeItem('token')
        logout()
    }
    const theme = useTheme()
    const { isWisesheets, branding } = useClientConfig()

    return (
        <StyledMoreContainer>
            <OutsideAlerter
                onpress={() => {
                    SetIsOpened(false)
                }}
            >
                <StyledNavItem onClick={() => SetIsOpened(!isOpened)}>
                    <StyledNavIcon>
                        <HiDotsHorizontal color={theme.colours.font.blue} />
                    </StyledNavIcon>
                    <StyledNavName>More</StyledNavName>
                </StyledNavItem>
                {isOpened ? (
                    <StyledDropDownMenu>
                        <StyledDropDownLink
                            target="_blank"
                            href={branding.docsLink}
                        >
                            <StyledDropDownLinkIcon as={HiBookOpen} />
                            Documentation
                        </StyledDropDownLink>
                        <StyledDropDownLink
                            target="_blank"
                            href={branding.availableDataLink}
                        >
                            <StyledDropDownLinkIcon as={BsClipboard2DataFill} />
                            Available Data
                        </StyledDropDownLink>
                        <StyledDropDownLink
                            target="_blank"
                            href={`mailto:${branding.contactLink}`}
                        >
                            <StyledDropDownLinkIcon as={MdEmail} />
                            Contact
                        </StyledDropDownLink>
                        {isWisesheets && (
                            <>
                                <StyledDropDownLink
                                    target="_blank"
                                    href="https://discord.com/invite/z8PgPqhCxs"
                                >
                                    <StyledDropDownLinkIcon
                                        as={RiDiscordFill}
                                    />
                                    Discord
                                </StyledDropDownLink>
                                <StyledDropDownLink
                                    target="_blank"
                                    href="https://wisesheets.io/referral"
                                >
                                    <StyledDropDownLinkIcon
                                        as={HiCurrencyDollar}
                                    />
                                    Free Subscription
                                </StyledDropDownLink>
                            </>
                        )}

                        <StyledDropDownLink
                            as={NavLink}
                            to="/"
                            onClick={pressLogout}
                        >
                            <StyledDropDownLinkIcon as={HiLogout} />
                            Logout
                        </StyledDropDownLink>
                    </StyledDropDownMenu>
                ) : null}
            </OutsideAlerter>
        </StyledMoreContainer>
    )
}

const Nav = React.memo(() => {
    const { isWisesheets } = useClientConfig()
    return (
        <StyledNavContainer>
            <NavItem
                to="/feature/statement-dump"
                Icon={HiDocumentSearch}
                name="Financials"
            />
            <NavItem
                to={'/feature/function-builder'}
                Icon={HiCalculator}
                name="Functions"
            />
            <NavItem to="/feature/screener" Icon={HiDatabase} name="Screener" />
            {isWisesheets && (
                <NavItem
                    to="/feature/templates"
                    Icon={HiTemplate}
                    name="Templates"
                />
            )}

            <DropDownMenu />
        </StyledNavContainer>
    )
})

Nav.displayName = 'Nav'

export default Nav
